import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: "10px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6px 8px",
    borderRadius: "50%",
    aspectRatio: "1",
    width: "36px",
    height: "36px",
    backgroundColor: theme.palette.events.blueShade2,
  },
  icon: {
    fontSize: "18px",
  },
  header: {
    padding: "30px",
    paddingBottom: "0px",
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
  },
  headerText: {
    lineHeight: "22px",
  },
  closeButton: {
    minWidth: 34,
    height: 34,
    "& svg": {
      fill: theme.palette.events.textPrimary,
    },
  },
}));
